import { Inject, Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs';
import { ITenaWebShop } from '../../../../model/product/tena/tcw/ITenaWebShop';
import { ApiErrorHandler } from 'tridion.web.ui/src/app/angular/api/error/ApiErrorHandler';
import { AuthService } from 'tridion.web.ui/src/app/angular/login/adal/Auth.service';
import { ENVIRONMENT } from 'tridion.web.ui/src/app/angular/environment/ENVIRONMENT';
import { IEnvironment } from '../../../../environment/IEnvironment';
import { TenaService } from '../../../../product/tena/Tena.service';
import { BaseTCWCatalogApi } from './BaseTCWCatalogApi';
import { LiveStageService } from '../../../../environment/LiveStage.service';
import { TenaTCWCatalogApi } from '../tcw/TenaTCWCatalogApi';
import { ITenaTCWCatalog } from '../../../../model/product/tena/tcw/ITenaTCWCatalog';
import { TenaSegmentApi } from './../TenaSegmentApi';
import { ITenaSegment } from './../../../../model/product/tena/ITenaSegment.d';

@Injectable()
export class TenaWebShopApi extends BaseTCWCatalogApi<ITenaWebShop> {
    constructor(
        apiErrorHandler: ApiErrorHandler,
        authService: AuthService,
        @Inject(ENVIRONMENT) environment: IEnvironment,
        http: Http,
        tenaService: TenaService,
        readonly tenaService1: TenaService,
        liveStageService: LiveStageService,
        readonly tenaCatalogApi: TenaTCWCatalogApi,
        readonly tenaSegmentsApi: TenaSegmentApi
    ) {
        super(apiErrorHandler, authService, environment, http, tenaService, liveStageService);
    }

    getWebShops(countryId: number, segmentId: number): Observable<ITenaWebShop[]> {
        return this.getJson(`/${countryId}/${segmentId}`);
    }

    protected getBaseUrl() {
        this.tenaCatalogApi.getAll().subscribe((res: ITenaTCWCatalog[]) => {
            this.tenaService1.countries.next(res);
        });

        this.tenaSegmentsApi.getAll().subscribe((res: ITenaSegment[]) => {
            const consumerSegments = res.filter(segment => segment.isConsumerSegment);
            this.tenaService1.segments.next(consumerSegments);
        });

        return this.TCWBaseURl + 'webshop';
    }
}
